import React, { useMemo } from 'react';
import { LiliPlanType } from '../../flows/planUpgrade/constants';
import {
  BasicBadge, PremiumBadge, ProBadge, SmartBadge,
} from '../../assets/svg';

export interface LiliPlanBadgeProps {
    planType: LiliPlanType;
}

export const LiliPlanBadge = ({ planType }: LiliPlanBadgeProps) => {
  const asset = useMemo(() => {
    switch (planType) {
      case LiliPlanType.BASIC:
        return BasicBadge;
      case LiliPlanType.BASIC_V2:
        return BasicBadge;
      case LiliPlanType.PRO:
        return ProBadge;
      case LiliPlanType.PRO_V2:
        return ProBadge;
      case LiliPlanType.SMART:
        return SmartBadge;
      case LiliPlanType.PREMIUM:
        return PremiumBadge;
      default: return BasicBadge;
    }
  }, [planType]);

  return (
    <div>
      {asset && <img id='profileProBadge' alt='profileProBadge' src={asset} />}
    </div>
  );
};
